import React from 'react';
import { TableLoader } from './common/table-loader';
import { PageHeaderLoader } from './common/page-header-loader';
import { TABLE_LOADER_OPTIONS } from '../constants/table-loader-options';

type ListPageLoaderProps = TABLE_LOADER_OPTIONS & {
  hidePageHeader?: boolean;
  hidePageHeaderActions?: boolean;
};

export const ListPageLoader = ({
  hideHeader,
  hideSearchBar,
  hideFilters,
  columnsWidth,
  shouldRightAlignLastCol,
  columnsCount,
  filtersCount,
  hideActions,
  rowsCount,
  hidePageHeader,
  hidePageHeaderActions,
}: ListPageLoaderProps) => {
  return (
    <div data-testid="list-page-loader">
      {!hidePageHeader && <PageHeaderLoader hideActions={hidePageHeaderActions} />}
      <br />
      <br />
      <TableLoader
        hideSearchBar={hideSearchBar}
        hideFilters={hideFilters}
        columnsWidth={columnsWidth}
        shouldRightAlignLastCol={shouldRightAlignLastCol}
        columnsCount={columnsCount}
        filtersCount={filtersCount}
        hideActions={hideActions}
        rowsCount={rowsCount}
        hideHeader={hideHeader}
      />
      <br />
    </div>
  );
};
